import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocalization } from '~/framework';
import { MediaInputValue, MediaInputComponent } from '~/ui-components';

type UploadMediaComponentProps = {
   hideInfoMsg: boolean;
   setHideInfoMsg: (hideInfoMsg: boolean) => void;
   onUploadMedia: (mediaData: object) => void;
   initialMediaValue: MediaInputValue | undefined;
   mediaFilter: 'guide_main_image' | 'guide_step_video';
   caption: string | undefined;
};

export const UploadMediaComponent = ({
   hideInfoMsg,
   setHideInfoMsg,
   onUploadMedia,
   initialMediaValue,
   mediaFilter,
   caption,
}: UploadMediaComponentProps) => {
   const { _js } = useLocalization();
   const displayType = mediaFilter === 'guide_main_image' ? 'an image' : 'a video';
   return (
      <Box alignItems="center">
         {!hideInfoMsg && (
            <Stack>
               <Text
                  textAlign="center"
                  fontWeight="600"
                  fontFamily="var(--sjs-font-family, var(--font-family, var(--sjs-default-font-family)))"
                  fontSize="var(--sjs-font-questiontitle-size, var(--sjs-font-size, 16px))"
                  color="var(--sjs-font-questiondescription-color, var(--sjs-general-forecolor-light, rgba(0, 0, 0, 0.45)))"
               >
                  {_js('Click below to upload %1 to add to the quiz', displayType)}
               </Text>
            </Stack>
         )}
         <MediaInputComponent
            filter={mediaFilter}
            initialValue={initialMediaValue}
            fieldName="quizQuestionImageInput"
            mt="15px"
            justifyContent="center"
            w="100%"
            changeFn={ev => {
               if (ev) {
                  onUploadMedia({
                     imageId: ev.id,
                     mediaType: ev.type,
                  });
                  setHideInfoMsg(true);
               } else {
                  setHideInfoMsg(false);
               }
            }}
         />
         <Text fontSize="lg" pt="20px">
            {caption}
         </Text>
      </Box>
   );
};
